import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import CardThumbnail from '@adv-mt/mt-card-thumbnail'

import {CONFIG_BY_OFFER_TYPE_NEW, CONFIG_BY_OFFER_TYPE_RENTING} from './config.js'
import {getMakeModelSlugs} from './helpers.js'

export default function CardBestOffer({ad, showMoreOffersLink, linkFactory: LinkFactory}) {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {OFFER_TYPE_NEW, OFFER_TYPE_SECOND_HAND, OFFER_TYPE_KM0, OFFER_TYPE_SUBSCRIPTION} = config.get('search')
  const PAGE_PATH_PATTERNS = config.get('page')

  const CONFIG_BY_OFFER_TYPE = {
    [OFFER_TYPE_KM0]: CONFIG_BY_OFFER_TYPE_NEW,
    [OFFER_TYPE_SECOND_HAND]: CONFIG_BY_OFFER_TYPE_NEW,
    [OFFER_TYPE_NEW]: CONFIG_BY_OFFER_TYPE_NEW,
    [OFFER_TYPE_SUBSCRIPTION]: CONFIG_BY_OFFER_TYPE_RENTING
  }

  if (!ad) return <></>

  const offerTypeId = ad.offerType?.id || OFFER_TYPE_SECOND_HAND

  const getListAdsUrl = ({ad}) => {
    const {makeSlug, modelSlug} = getMakeModelSlugs({ad}) || {}
    if (!makeSlug || !modelSlug) return null
    return PAGE_PATH_PATTERNS[CONFIG_BY_OFFER_TYPE[offerTypeId].pathPattern]
      .replace(':make', makeSlug)
      .replace(':model', modelSlug)
  }

  const moreOffersLabel = i18n.t(CONFIG_BY_OFFER_TYPE[offerTypeId].title, {
    makeModel: `${ad.make?.name} ${ad.model?.name}`
  })

  const moreOffersLink = showMoreOffersLink && getListAdsUrl({ad})
  const hasMoreOffers = !!moreOffersLink

  const cardThumbnailProps = CONFIG_BY_OFFER_TYPE[offerTypeId]?.mapper({ad, i18n})

  return (
    <div className="mt-CardBestOffer">
      <CardThumbnail {...cardThumbnailProps} />
      {showMoreOffersLink && hasMoreOffers && (
        <LinkFactory className="mt-CardBestOffer-link" href={moreOffersLink}>
          {moreOffersLabel}
        </LinkFactory>
      )}
    </div>
  )
}

CardBestOffer.displayName = 'CardBestOffer'
CardBestOffer.propTypes = {
  ad: PropTypes.object.isRequired,
  linkFactory: PropTypes.func,
  showMoreOffersLink: PropTypes.bool
}
